import React from 'react'

class Chain extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
        <path
          fill="#1B66B3"
          fillRule="evenodd"
          d="M11.569 6.008l.65-.651A1.765 1.765 0 0 0 9.725 2.86L6.917 5.67a2.206 2.206 0 0 0 0 3.12l-1.248 1.247a3.97 3.97 0 0 1 0-5.615l2.807-2.808a3.53 3.53 0 0 1 4.992 4.992l-1.58 1.579a5.31 5.31 0 0 0-.32-2.176zM3.513 9.073l-.652.651a1.765 1.765 0 0 0 2.496 2.496l2.807-2.808a2.206 2.206 0 0 0 0-3.12l1.248-1.247a3.97 3.97 0 0 1 0 5.615l-2.807 2.808a3.53 3.53 0 0 1-4.992-4.992l1.58-1.579a5.31 5.31 0 0 0 .32 2.176z"
        />
      </svg>
    )
  }
}

export default Chain
